import { render } from "./announcementList.vue?vue&type=template&id=6ca84486&scoped=true"
import script from "./announcementList.vue?vue&type=script&lang=js"
export * from "./announcementList.vue?vue&type=script&lang=js"

import "./announcementList.vue?vue&type=style&index=0&id=6ca84486&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca84486"]])

export default __exports__